import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { authModule, userModule } from '../../../store'
import { InputIrmao, InputLojaIrmao } from '../../../../common/types/Irmao'
import { obrigatorio } from '../../../shareds/regras'
import { intersectRoles } from '../../../helpers/auth-helpers'
import SeletorDeSituacaoDoMacon from '@/components/SeletorDeSituacaoDoMacon.vue'
import SeletorDeLojas from '@/components/SeletorDeLojas.vue'
import { adminLojaGuard as guardaDeAdminDaLoja } from '../../../shareds/sharedsLoja'
import { adminPotenciaGuard as guardaDeAdminDaPotencia } from '@/shareds/sharedsPotencia'
import SeletorDeCargos from '@/components/SeletorDeCargos.vue'


const __default__ = {
	model: {
		prop: 'irmao',
	},
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FormLojas',
  props: {
	irmao: { type: Object as PropType<InputIrmao>, required: true },
},
  setup(__props) {

const props = __props;



function adicionarLojaSecundaria() {
	props.irmao.lojas.push(criarLojaSecundaria())
}

function removerLojaSecundaria(indice: number) {
	props.irmao.lojas.splice(indice, 1)
}

const adminLojaGuard = computed(() => (idLoja: string | null) => guardaDeAdminDaLoja(idLoja)(userModule.currentUser))

const adminPotenciaGuard = computed(() => guardaDeAdminDaPotencia(props.irmao.potencia)(userModule.currentUser))

function criarLojaSecundaria(): InputLojaIrmao {
	return {
		tipo: 'Secundária',
		loja: null,
		cargoDeAdminDaLoja: '',
		situacaoDoMacon: 'Regular',
	}
}

return { __sfc: true,props, adicionarLojaSecundaria, removerLojaSecundaria, adminLojaGuard, adminPotenciaGuard, criarLojaSecundaria, authModule, obrigatorio, intersectRoles, SeletorDeSituacaoDoMacon, SeletorDeLojas, SeletorDeCargos }
}

})